module.exports = __webpack_public_path__ + "static/img/ios_xz.c9e0a51.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ios_xz.png
// module id = nGLI
// module chunks = 1